<template>
<div>
    <div class="meeting-header">
      <p class="text-center"><img style="margin:0 auto" :src="state.meetingData.event.image" alt="" class="img-responsive"></p>
        <h2>{{state.meetingData.event.title}}</h2>
        <p>{{state.meetingData.event.where}}</p>
    </div>
</div>
</template>

<script>
  import { mapGetters } from 'vuex'
  export default {
    name: 'Header',
    computed: {
      ...mapGetters({
        state: 'getState',
      }),
    },
  }
</script>

<style scoped>
    .meeting-header{
        background: #b7b7b71c;
        padding: 15px;
        border-radius: 5px;
        margin-bottom: 15px;
    }
</style>
